import { createSlice } from '@reduxjs/toolkit';

import { loadExpertiseList } from './expertise-list.middleware';
import { logout } from '../auth/auth-middleware';

type State = {
    data: object | null;
    error: string | null;
    isLoading: boolean;
};

const initialState: State = {
    data: null,
    error: null,
    isLoading: false,
};

export const expertiseListSlice = createSlice({
    name: 'app/expertise_list',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadExpertiseList.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(loadExpertiseList.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadExpertiseList.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.data = null;
                state.error = null;
                state.isLoading = false;
            });
    },
});

export default expertiseListSlice.reducer;
